import React, { useEffect, useState, useContext } from "react";
import CanvasJSReact from "@canvasjs/react-charts";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { APICall } from "../../Helpers/Network/APICalls";
import {
  getConfigValues,
  checkShortTermLoanEligibility,
  checkLongTermLoanEligibility,
  getShortTermLoan,
  getAllLoanTypeList,
  postLoanDetails,
  getLoanRequestDataById,
  getShortTermAmountDropdown,
  getInstallmentDuration,
  loanModuleGetPersonalDetailsByMemberId,
  longTermCalculation,
  postLongTermLoanDetails,
  getEligibleLoanAmount,
} from "../../Helpers/APIEndPoints/EndPoints";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { Navigate, useLocation } from "react-router-dom";
import { LoanTypeEnum, LoanTypeNames } from "../../Helpers/Enums/Enum";
import InputForm from "../../Components/InputForm/InputForm";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { FormGroup } from "react-bootstrap";
import FormWithHeader from "../../Components/FormView/FormWithHeader";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { Decrypt, Encrypt } from "../../Helpers/Cryptography/Crypto";
import { useNavigate } from "react-router-dom";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";
import "./style.css";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { setIsLoanParams } from "../../Redux/Actions/LoanModuleAction";
import { useDispatch, useSelector } from "react-redux";
import { getFormattedCurrencyValueWithSymbol } from "../../Helpers/Common";
import InputFormFocus from "../../Components/InputForm/InputFormFocus";
import { debug } from "console";

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const LoanType = (props) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [termSelection, setTermSelection] = useState("");
  const [dummy, setDummy] = useState("");
  const [loanEligibilityText, setLoanEligibilityText] = useState([]);
  const [showNext, setShowNext] = useState(false);
  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [eligibleLoan, setEligibleLoan] = useState(false);
  const [longTermEligibleLoan, setLongTermEligibleLoan] = useState(false);
  const [loanTypeValue, setLoanTypeValue] = useState<any>([]);
  const [formErrors, setFormErrors] = useState({});
  const [calculateButton, setCalculateButton] = useState(false);

  const loanParameters = useSelector<any>((states) => states?.LoanModuleReducer);

  const [loanEmi, setLoanEmi] = useState(0);
  const [totalInterestPayable, setTotalInterestPayable] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);

  const [longLoanEmi, setLongLoanEmi] = useState(0);
  const [longTotalInterestPayable, setLongTotalInterestPayable] = useState(0);
  const [longTotalPayment, setLongTotalPayment] = useState(0);

  const [aLTLLongLoanEmi, setALTLLongLoanEmi] = useState(0);
  const [aLTLLongTotalInterestPayable, setALTLLongTotalInterestPayable] = useState(0);
  const [aLTLLongTotalPayment, setALTLLongTotalPayment] = useState(0);
  const [isResetClicked, setIsResetClicked] = useState(false);

  let MemberId = context.MemberId;
  // let navigate = useNavigate();
  let formErrorObj = {};

  const [shortTermData, setShortTermData] = useState({
    loanAmount: null,
    interestRate: 0,
    duration: null,
    loanEmi: null,
    totalInterestPayable: null,
    totalPayment: null,
  });
  const [longTermData, setLongTermData] = useState<any>({
    ltlAmount: 0,
    ltlEligibleAmount: 0,
    ltlGiveableAmount: "",
    ltlRoi: 0,
    previousOutstandingLoan: 0,
    previousOutstandingLoanAL: 0,
    totalSanctionableLoan: 0,
    loanType: 0,
    altlAmount: 0,
    altlEligibleAmount: 0,
    altlGiveableAmount: "",
    altlRoi: 0,
    minDuration: 0,
    maxDuration: 0,
    minAltlDuration: 0,
    maxAltlDuration: 0,
    altlLoanType: 0,
    ltlTotalLoanToBeGiven: 0,
    altlTotalLoanToBeGiven: 0
  });
  const [disabled, setDisable] = useState(false);
  const [error, setError] = React.useState<any>({});
  const [disabledCalculateButton, setDisabledCalculateButton] = useState(true);
  const [loanTypeOption, setLoanTypeOption] = useState([]);
  const [formDataOnEdit, setFormDataOnEdit] = useState();
  const [loanAmountDropData, setLoanAmountDropData] = useState<any>();
  const [durationDropData, setDurationDropData] = useState([
    { value: 1, label: 6 },
    { value: 2, label: 12 },
  ]);

  useEffect(() => {
    GetShortTermAmountDropdown();
    getDropDownDataApiCall();
    callConfigData();
    getPersonalDetailsById();
    if (state.Id != 0 && state.Id != null) {
      getLoanRequestDataByIds();
    }
  }, []);

  useEffect(() => {
    if (isResetClicked) {
      props.next();
    }
  }, [isResetClicked]);

  useEffect(() => {
    if (shortTermData.loanAmount != null && shortTermData.duration != null) {
      setDisabledCalculateButton(false);
    }
  }, [shortTermData]);

  useEffect(() => {
    if (loanTypeOption.length > 0 && formDataOnEdit != "" && formDataOnEdit != undefined && formDataOnEdit != null) {
      // Find data with label "shortterm"
      const shortTermData = loanTypeOption.find((item) => item.value == formDataOnEdit);
      setTermSelection(shortTermData?.label);
      getTermDataFn(shortTermData);
    }
  }, [loanTypeOption, formDataOnEdit]);

  const toggleShowNext = () => {
    if (loanTypeValue?.value == LoanTypeEnum.LONGTERM) {
      GetLongTermLoan();
    }

    setShowNext(!showNext);
  };
  const GetLongTermLoan = async () => {
    showLoader();
    const config = {
      // LoanTypeName: LoanTypeNames.LTL,
      MemberId: MemberId,
    };

    const result = await APICall(getEligibleLoanAmount, config);
    if ((result.Message == "Success" || result.Message == "Ok") && result.Data) {
      setDisable(true);
      setLongTermData({
        ...longTermData,
        previousOutstandingLoan: result?.Data?.PreviousLoanBalance,
        previousOutstandingLoanAL: result?.Data?.PreviousLoanBalanceAL,
        minDuration: result?.Data?.MinTenure,
        maxDuration: result?.Data?.MaxTenure,
        loanType: result?.Data?.LTLoanType,
        altlLoanType: result?.Data?.AltlLoanType,
        totalSanctionableLoan: result?.Data?.SanctionAmount,
        ltlAmount: result?.Data?.LTLMaxAmountRevised,
        ltlEligibleAmount: result?.Data?.LTLEligibleAmount,
        //ltlGiveableAmount: result?.Data?.LTLEligibleAmount,
        ltlRoi: result?.Data?.LTLRateOfInterest,
        altlAmount: result?.Data?.ALTLMaxAmountRevised,
        altlEligibleAmount: result?.Data?.ALTLEligibleAmount,
        // altlGiveableAmount: result?.Data?.ALTLEligibleAmount,
        altlRoi: result?.Data?.ALTLRateOfInterest,
      });

      // minAltlDuration: result?.Data?.ALTLMinTenure,
      // maxAltlDuration: result?.Data?.ALTLMaxTenure,
    }
    hideLoader();
  };

  const getPersonalDetailsById = async () => {
    showLoader();
    let requestParams = loanParameters?.["loanParameters"]; // { MemberId: MemberId };

    const res = await APICall(loanModuleGetPersonalDetailsByMemberId, requestParams);

    if (res.Message === "Ok" && res.Data !== null) {
      switch (res?.Data?.Lrd_StatusId) {
        case LoanStatus.LoanModule_SuretyApprovalPending:
        case LoanStatus.LoanModule_AllSuretyApproved:
        case LoanStatus.LoanModule_Draft:
          setEligibleLoan(false);
          setDisabledCalculateButton(true);
          setCalculateButton(true);
          break;
        default:
          // Handle default case if needed
          break;
      }
      hideLoader();
    }
  };

  const getLongAndAdditionTermCal = async () => {
    
    if (longTermData.maxDuration < 6) {
      notify(ToastType.Error, "Max Duration should be greater than 6 months");
      return;
    }


    if (!longTermData.ltlGiveableAmount || longTermData.ltlGiveableAmount <= 0) {
      notify(ToastType.Error, "Long Term Loan Amount Applied must be greater than zero");
      return;
    }

    // Check if Long Term Loan Amount Applied is a multiple of 1000
    if (longTermData.ltlGiveableAmount % 1000 !== 0) {
      notify(ToastType.Error, "Long Term Loan Amount Applied should be multiplication of 1000");
      return;
    }

    // if (!longTermData.altlGiveableAmount || longTermData.altlGiveableAmount <= 0) {
    //   notify(ToastType.Error, "Additional Long Term Loan Amount Giveable must be greater than zero");
    //   return;
    // }

    if (longTermData.ltlGiveableAmount > longTermData.ltlEligibleAmount) {
      notify(ToastType.Error, "Long Term Loan Amount Applied cannot be greater than Eligible Amount");
      return;
    }

    if (longTermData.altlGiveableAmount > longTermData.altlEligibleAmount) {
      notify(ToastType.Error, "Additional Long Term Loan Amount Applied cannot be greater than Eligible Amount");
      return;
    }

    // Check if Additional Long Term Loan Amount Applied is a multiple of 1000 (only if amount is entered)
    if (longTermData.altlGiveableAmount && longTermData.altlGiveableAmount > 0 && longTermData.altlGiveableAmount % 1000 !== 0) {
      notify(ToastType.Error, "Additional lLong Term Loan Amount Applied should be multiplication of 1000");
      return;
    }

    if (longTermData.ltlTotalLoanToBeGiven <= 0) {
      notify(ToastType.Error, "Loan amount cannot be negative");
      return;
    }
    showLoader();
    // LTLEligibleAmount: parseFloat(Number(longTermData.ltlGiveableAmount).toFixed(2)),
    // ALTLEligibleAmount: parseFloat(Number(longTermData.altlGiveableAmount).toFixed(2)),
    const config = {
      LTLEligibleAmount: longTermData.ltlGiveableAmount,
      Duration: longTermData.maxDuration,
      LTLLoanTypeId: longTermData.loanType,
      ALTLEligibleAmount: longTermData.altlGiveableAmount ? longTermData.altlGiveableAmount : 0,
      ALTLLoanTypeId: longTermData.altlLoanType,
      MemberId: MemberId,
    };
    
    const result = await APICall(longTermCalculation, config);

    if ((result.Message == "Success" || result.Message == "Ok") && result.Data) {
      setLongLoanEmi(result?.Data?.LongTermData?.LTLEmi);
      setLongTotalInterestPayable(result?.Data?.LongTermData?.TotalLTLInterestPayable);
      setLongTotalPayment(result?.Data?.LongTermData?.TotalLTLPayment);

      setALTLLongLoanEmi(result?.Data?.AdditionalLongTermData?.ALTLEmi);
      setALTLLongTotalInterestPayable(result?.Data?.AdditionalLongTermData?.TotalALTLInterestPayable);
      setALTLLongTotalPayment(result?.Data?.AdditionalLongTermData?.TotalALTLPayment);

      if (result?.Data?.LongTermData?.TotalLTLInterestPayable > 0 && result?.Data?.LongTermData?.LTLEmi > 0) {
        setLongTermEligibleLoan(true);
      }
    }
    hideLoader();
  };

  const GetShortTermAmountDropdown = async () => {
    showLoader();
    const result = await APICall(getShortTermAmountDropdown, {});

    if ((result.Message == "Success" || result.Message == "Ok") && result.Data) {
      setLoanAmountDropData(result?.Data);
    }
    hideLoader();
  };

  const GetInstallmentDuration = React.useCallback(async (val) => {
    showLoader();
    const result = await APICall(getInstallmentDuration, {
      LoanAmount: val?.label,
    });
    if ((result.Message == "Success" || result.Message == "Ok") && result.Data) {
      setShortTermData((prev) => ({
        ...prev,
        loanAmount: val,
        interestRate: result.Data.RateOfInterest,
        duration: result.Data.InstallmentPeriod,
      }));
      setEligibleLoan(false);
    }
    hideLoader();
  }, [showLoader, hideLoader]);

  const callConfigData = async () => {
    const config = ["LoanEligibility", "LongTermLoanMinMonthsDuration", "LongTermLoanMaxMonthsDuration"];

    const result = await APICall(getConfigValues, { Keys: config });

    if (result && result.Message == "Ok" && result.Data.length > 0) {
      result.Data.map((cd) => {
        if (cd.Key === "LoanEligibility") {
          // setLoanEligibilityText(cd.Value);
        }
        if (cd.Key === "LongTermLoanMinMonthsDuration") {
          onChangeLongTermData("minDuration", cd.Value);
        }
        if (cd.Key === "LongTermLoanMaxMonthsDuration") {
          onChangeLongTermData("maxDuration", cd.Value);
        }
      });
    }
  };

  const handleKeyNumbers = React.useCallback((event) => {
    const charCode = event.which || event.keyCode; // Handle cross-browser compatibility
    if (charCode >= 48 && charCode <= 57) {
      // Prevent numeric character input
      event.preventDefault();
    }
  }, []);

  const handleKeyPress = React.useCallback((event) => {
    // Prevent typing of minus sign (-)
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  }, []);

  const onChangeShortTermData = React.useCallback((key, value) => {
    setShortTermData((prev) => ({ ...prev, [key]: value }));
  }, []);

  // const onChangeLongTermData = React.useCallback((key, value) => {
  //   setLongTermEligibleLoan(false);
  //   setLongTermData((prev) => ({ ...prev, [key]: value }));
  // }, []);

  // const onChangeLongTermData = React.useCallback((key, value) => {
  //   setLongTermEligibleLoan(false);
  //   setLongTermData((prev) => {
  //     debugger;
  //     const newData = { ...prev, [key]: value };

  //     if (key === 'ltlGiveableAmount' && newData.altlGiveableAmount > 0) {
  //       newData.ltlTotalLoanToBeGiven = parseInt(value || "0") - parseInt(prev.previousOutstandingLoan || 0)- Math.abs(newData.altlGiveableAmount - parseInt(prev.previousOutstandingLoanAL || 0));
  //     }
  //     else if(key === 'ltlGiveableAmount' && newData.altlGiveableAmount == 0){
  //       if(parseInt(value || "0") > 0){
  //         newData.ltlTotalLoanToBeGiven = (parseInt(value || "0") - parseInt(prev.previousOutstandingLoan || 0)) - Math.abs(newData.altlTotalLoanToBeGiven);
  //       }
  //       else{
  //             newData.ltlTotalLoanToBeGiven = (parseInt(value || "0") - parseInt(prev.previousOutstandingLoan || 0))
  //       }
  //     }
  //     if (key === 'altlGiveableAmount') {
  //       debugger;
  //       const altlGiveable = parseInt(value || "0");
  //       if (altlGiveable === 0) {
  //         newData.altlTotalLoanToBeGiven = altlGiveable - parseInt(prev.previousOutstandingLoanAL || 0);
  //         newData.altlGiveableAmount = value;
  //         //  newData.altlTotalLoanToBeGiven = 0;
  //       if((parseInt(prev.ltlGiveableAmount || "0")) > 0){
  //         newData.ltlTotalLoanToBeGiven = (parseInt(prev.ltlGiveableAmount || "0") - parseInt(prev.previousOutstandingLoan || 0)) - Math.abs(newData.altlTotalLoanToBeGiven);
  //       }
  //       else{
  //             newData.ltlTotalLoanToBeGiven = (parseInt(prev.ltlGiveableAmount || "0") - parseInt(prev.previousOutstandingLoan || 0));

  //       }
  //         newData.altlTotalLoanToBeGiven = 0;
  //       } else {
  //         newData.ltlTotalLoanToBeGiven = parseInt(prev.ltlGiveableAmount || "0") - parseInt(prev.previousOutstandingLoan || 0);
  //         newData.altlTotalLoanToBeGiven = altlGiveable - parseInt(prev.previousOutstandingLoanAL || 0);
  //       }
  //     }
  //     return newData;
  //   });
  // }, []);
  const toNumber = (v: any) => parseInt(v || "0", 10);

  const onChangeLongTermData = React.useCallback((key, value) => {
    setLongTermEligibleLoan(false);

    setLongTermData(prev => {
      const data = { ...prev, [key]: value };

      const ltlGiveable = toNumber(
        key === "ltlGiveableAmount" ? value : prev.ltlGiveableAmount
      );
      const altlGiveable = toNumber(
        key === "altlGiveableAmount" ? value : prev.altlGiveableAmount
      );
      debugger;
      const prevLTLOut = toNumber(prev.previousOutstandingLoan);
      const prevALTLOut = toNumber(prev.previousOutstandingLoanAL);

      // ---------- ALT TOTAL ----------
      data.altlTotalLoanToBeGiven = Math.abs(
        altlGiveable - prevALTLOut
      );

      // ---------- LTL TOTAL ----------
      const ltlBase = (ltlGiveable - prevLTLOut);
      if (altlGiveable === 0 || altlGiveable < prevALTLOut) {
        data.ltlTotalLoanToBeGiven = ltlBase - data.altlTotalLoanToBeGiven
        data.altlTotalLoanToBeGiven = 0;
      }
      else {
        data.ltlTotalLoanToBeGiven = ltlBase;
        data.altlTotalLoanToBeGiven = data.altlTotalLoanToBeGiven;
      }

      return data;
    });
  }, []);

  const options = {
    title: {
      text: "Break-up of the Total Payment",
    },
    data: [
      {
        type: "pie",
        showInLegend: true,
        legendText: "{label}",
        toolTipContent: `{label}: <strong>${getFormattedCurrencyValueWithSymbol("{y}")}</strong>`,
        indexLabel: getFormattedCurrencyValueWithSymbol("{y}"),
        indexLabelPlacement: "inside",
        dataPoints: [
          {
            label: "Principal Loan Amount",
            y: parseInt(shortTermData.loanAmount?.label), // 100 - longTermData.ltlRoi,
            color: "#88a825",
          },
          {
            label: "Total Interest",
            y: totalInterestPayable,
            color: "#ed892b",
            exploded: true,
          },
          // { label: "Total Interest", y: 15.2, color: "Green", exploded: true },
        ],
      },
    ],
    width: 350, // Set the width of the chart
    height: 250, // Set the height of the chart
    fontSize: 14, // Set the font size for the chart
    // animationEnabled: true,
  };

  const ltiOption = {
    title: {
      text: "Long Term",
    },
    data: [
      {
        type: "pie",
        showInLegend: true,
        legendText: "{label}",
        toolTipContent: `{label}: <strong>${getFormattedCurrencyValueWithSymbol("{y}")}</strong>`,
        indexLabel: getFormattedCurrencyValueWithSymbol("{y}"),
        indexLabelPlacement: "inside",
        dataPoints: [
          {
            label: "Principal Loan Amount",
            y: parseInt(longTermData.ltlGiveableAmount),
            color: "#88a825",
          },
          {
            label: "Total Interest",
            y: longTotalInterestPayable, //longTermData.ltlRoi,
            color: "#ed892b",
            exploded: true,
          },
          // { label: "Principal Loan Amount", y: 84.8, color: "RoyalBlue" },
          // { label: "Total Interest", y: 15.2, color: "Green", exploded: true },
        ],
      },
    ],
    width: 350, // Set the width of the chart
    height: 250, // Set the height of the chart
    fontSize: 14, // Set the font size for the chart
    // animationEnabled: true,
  };

  const altiOption = {
    title: {
      text: "Additional Long Term",
    },
    data: [
      {
        type: "pie",
        showInLegend: true,
        legendText: "{label}",
        toolTipContent: `{label}: <strong>${getFormattedCurrencyValueWithSymbol("{y}")}</strong>`,
        indexLabel: getFormattedCurrencyValueWithSymbol("{y}"),
        indexLabelPlacement: "inside",
        dataPoints: [
          {
            label: "Principal Loan Amount",
            y: parseInt(longTermData.altlGiveableAmount),
            color: "#88a825",
          },
          {
            label: "Total Interest",
            y: aLTLLongTotalInterestPayable,
            color: "#ed892b",
            exploded: true,
          },
        ],
      },
    ],
    width: 350, // Set the width of the chart
    height: 250, // Set the height of the chart
    fontSize: 14, // Set the font size for the chart
    // animationEnabled: true,
  };

  const GetShortTermLoan = async () => {
    showLoader();
    const config = {
      MemberId: MemberId,
      LoanAmount: shortTermData?.loanAmount?.label,
      Duration: shortTermData?.duration?.label,
      LoanType: loanTypeValue?.value,
    };
    const result = await APICall(getShortTermLoan, config);

    if ((result.Message == "Success" || result.Message == "Ok") && result.Data) {
      setLoanEmi(result.Data.LoanEmi);
      setTotalInterestPayable(result.Data.TotalInterestPayable);
      setTotalPayment(result.Data.TotalPayment);
      setEligibleLoan(true);
    }
    hideLoader();
  };

  const onSubmitValidation = async () => {
    setFormErrors({});
    formErrorObj = {};

    if (!shortTermData?.loanAmount || Object.keys(shortTermData?.loanAmount).length < 0) {
      formErrorObj["loanAmount_isEmpty"] = "Loan amount can not be empty or Zero(0)";
    }
    setFormErrors(formErrorObj);
  };
  const onLongTermSubmit = async () => {
    if (longTermData.ltlTotalLoanToBeGiven <= 0) {
      notify(ToastType.Error, "Loan amount cannot be negative");
      return;
    }

    showLoader();
    let param = {
      LoanId: state.Id != 0 && state.Id != null ? state.Id : 0,
      MemberId: MemberId,
      LTLLoanTypeId: longTermData.loanType,
      ALTLLoanTypeId: longTermData.altlLoanType,
      LTLEligibleAmount: longTermData.ltlGiveableAmount,
      ALTLEligibleAmount: longTermData.altlGiveableAmount ? longTermData.altlGiveableAmount : 0,
      InstallmentPeriod: longTermData.maxDuration,
      EMI: longLoanEmi,
      ROI: longTermData.ltlRoi,
      ALTLEMI: aLTLLongLoanEmi,
      ALTLROI: longTermData.altlRoi,
      Reason: 0,
      StatusId: LoanStatus.LoanModule_Draft,
      ModifiedBy: context.Id,
    };
    const insertData = await APICall(postLongTermLoanDetails, param);
    // spInsertUpdateLongTermLoanDetails
    if (insertData?.Status == ApiStatus.OK) {
      dispatch(setIsLoanParams({ LoanId: insertData?.Data, MemberId: MemberId }));
      setIsResetClicked(true);
    } else {
      notify(ToastType.Error, insertData?.Message || "Failed to upload document, Please try again later.");
    }
    hideLoader();
  };

  const onSubmit = async () => {
    await onSubmitValidation();
    let isEmpty = Object.values(formErrorObj).every((f) => {
      return f === "" || f === null || f === undefined;
    });

    if (disabled) {
      await props.next();
      return;
    }

    if (isEmpty === true) {
      showLoader();

      let param = {
        LoanId: state.Id != 0 && state.Id != null ? state.Id : 0,
        MemberId: MemberId,
        LoanTypeId: loanTypeValue?.value,
        LoanAmount: shortTermData?.loanAmount?.label,
        InstallmentPeriod: shortTermData?.duration,
        Reason: 0,
        EMI: loanEmi,
        ROI: shortTermData?.interestRate,
        StatusId: LoanStatus.LoanModule_Draft,
        ModifiedBy: context.Id,
      };
      const insertData = await APICall(postLoanDetails, param);
      // spInsertUpdateLoanDetails
      if (insertData?.Data) {
        setIsResetClicked(true);
        dispatch(setIsLoanParams({ LoanId: insertData?.Data, MemberId: MemberId }));
        // localStorage.setItem(
        //   "Lo anRequestId",
        //   Encrypt(JSON.stringify(insertData?.Data))
        // );
        // notify(ToastType.Success, "Successfully data inserted");
        props.next();
      } else {
        notify(ToastType.Error, insertData?.Message || "Failed to upload document, Please try again later.");
        hideLoader();
        return;
      }
    }
    hideLoader();
  };

  // setShortTermData({
  //     ...shortTermData,
  //     interestRate: result.Data.RateOfInterest
  // });

  const ShortTermComponent = React.useMemo(() => (
    <div className="m-3 p-3 border border-danger" style={{ borderRadius: 20 }}>
      {/* mt-3 */}
      <div className="col-lg-12 col-md-12 pt-5">
        <div className="row">
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Loan Amount</label>
            <sup>*</sup>
            <SelectForm
              value={shortTermData.loanAmount}
              placeholder="Loan Amount"
              options={loanAmountDropData}
              isDisabled={disabled}
              onChange={(val: any) => {
                GetInstallmentDuration(val);
              }}
            />
            <p style={{ color: "red" }}>{formErrors["loanAmount_isEmpty"]}</p>
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4">
            <div className="form-group"></div>
            <label>Interest rate</label>
            <InputForm
              placeholder={""}
              value={shortTermData.interestRate}
              onChange={(val: any) => {
                let value = val.target.value;
                onChangeShortTermData("interestRate", value);
              }}
              isDisabled={true}
              onKeyPress={handleKeyNumbers}
              maxLength={30}
            />
            {error[shortTermData.loanAmount] && <p style={{ color: "red" }}>{error[shortTermData.loanAmount]}</p>}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Duration</label>
            <InputForm placeholder={""} value={shortTermData.duration} isDisabled={true} />
            {/* <SelectForm
                value={shortTermData.duration}
                placeholder="Duration"
                options={durationDropData}
                isDisabled={true}
                onChange={(val: any) => onChangeShortTermData("duration", val)}
              />
              {error[shortTermData.duration] && (
                <p style={{ color: "red" }}>{error[shortTermData.duration]}</p>
              )} */}
          </div>
        </div>
        <div className="d-flex justify-content-center my-4">
          <ButtonComponent
            icon={""}
            value={"Calculate"}
            id="saveBtn"
            disabled={disabledCalculateButton}
            onClick={async () => {
              await GetShortTermLoan();
            }}
          />
        </div>
        <div className="row m-3 border border-danger p-3 align-items-center" style={{ borderRadius: 20 }}>
          <div className="col px-md-5">
            <div className="column">
              <p>Loan EMI</p>
              <h5>
                <i className="fa fa-inr"></i> {loanEmi != null && loanEmi.toLocaleString("en-IN")}
              </h5>
              <p>Total Interest Payable</p>
              <h5>
                <i className="fa fa-inr"></i> {totalInterestPayable != null && totalInterestPayable.toLocaleString("en-IN")}
              </h5>
              <p>Total Payment</p>
              <p>(Principal + Interest)</p>
              <h5>
                <i className="fa fa-inr"></i> {totalPayment != null && totalPayment.toLocaleString("en-IN")}
              </h5>
            </div>
          </div>

          <div className="col px-md-5">
            <CanvasJSChart
              options={options}
            /* onRef = {ref => this.chart = ref} */
            />
          </div>
        </div>
        <div className="d-flex justify-content-center m-3">
          <div className="column">
            <h4> {eligibleLoan ? "You're Eligible for Loan!" : ""}</h4>

            <div className="d-flex justify-content-around m-3">
              <div className="row">
                <ButtonComponent
                  icon={""}
                  value={"Back"}
                  onClick={() => {
                    // toggleShowNext();
                    navigate("/LoanApprovalDashboard");
                  }}
                />
                <ButtonComponent
                  icon={""}
                  value={"Proceed"}
                  id="saveBtn"
                  className={"btn btn-primary"}
                  style={{ marginLeft: "10px" }}
                  disabled={!eligibleLoan}
                  onClick={() => {
                    onSubmit();
                    // props.next();
                    // toggleShowNext();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ), [
    shortTermData,
    loanAmountDropData,
    disabled,
    formErrors,
    error,
    disabledCalculateButton,
    loanEmi,
    totalInterestPayable,
    totalPayment,
    eligibleLoan,
    GetInstallmentDuration,
    onChangeShortTermData,
    handleKeyNumbers,
    navigate,
  ]);

  const LongTermComponent = React.useMemo(() => (
    <div className="mx-3 border border-danger" style={{ borderRadius: 20 }}>
      <div className="col-lg-12 col-md-12 mt-3 pt-5">
        <div className="row">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <table className="table">
                  <tr>
                    <td className="tableData">Long Term Loan Amount: </td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {parseInt(longTermData.ltlAmount)
                        .toLocaleString("en-IN")}
                    </td>
                  </tr>
                  <tr>
                    <td className="tableData">Long Term Loan Eligible Amount:</td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {parseInt(longTermData.ltlEligibleAmount)
                        .toLocaleString("en-IN")}
                    </td>
                  </tr>
                  <tr>
                    <td className="tableData">Long Term Loan Amount Applied:</td>
                    <td className="tableData">
                      <InputForm
                        placeholder={""}
                        value={longTermData.ltlGiveableAmount}
                        onChange={(val: any) => {
                          let value = val.target.value;
                          const regex = /^[0-9]*$/;
                          if (value === "" || regex.test(value)) {
                            onChangeLongTermData("ltlGiveableAmount", value);
                          }
                        }}
                        type="number"
                        onKeyPress={(e) => handleKeyPress(e)}
                        isDisabled={false}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="tableData">Long Term Loan Rate Of Interest:</td>
                    <td className="tableData" style={{ paddingLeft: "30px" }}>
                      {longTermData.ltlRoi}%
                    </td>
                  </tr>

                  {/* <tr>
                      <td className="tableData">Total Sanctioned loan:</td>
                      <td className="tableData">
                        <i className="fa fa-inr"></i>
                        {parseInt(longTermData.totalSanctionableLoan)
                          .toString()
                          .replace(/(\d)(?=(\d{2})+\d(?!\d))/g, "$1,")}
                      </td>
                    </tr> */}
                  <tr>
                    <td className="tableData">Previous Outstanding Loan:</td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {parseInt(longTermData.previousOutstandingLoan)
                        .toLocaleString("en-IN")}
                    </td>
                  </tr>
                  <tr>
                    <td className="tableData">Total Loan To Be Given:</td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {(
                        (parseInt(longTermData.ltlTotalLoanToBeGiven) || 0) +
                        (parseInt(longTermData.altlTotalLoanToBeGiven) || 0)
                      )
                        .toLocaleString("en-IN")}
                    </td>
                  </tr>

                  <tr>
                    <td className="tableData">
                      Duration: Min
                      <InputForm
                        placeholder={""}
                        value={longTermData.minDuration}
                        onChange={(val: any) => {
                          let value = val.target.value;
                          onChangeLongTermData("minDuration", value);
                        }}
                        type="number"
                        disabled={disabled}
                        onKeyPress={(e) => handleKeyPress(e)}
                        style={{ width: "50%" }}
                      // onWheel={(e) => e.target.blur()}
                      />{" "}
                      Months
                    </td>
                    <td className="tableData">
                      Max
                      <InputFormFocus
                        placeholder={""}
                        value={longTermData.maxDuration}
                        onChange={(val: any) => {
                          let value = val.target.value;

                          // Ensure only numeric values are allowed
                          const regex = /^[0-9]+$/;
                          if (value === "" || regex.test(value)) {
                            // Limit the length of the input
                            if (value.length > 2) {
                              value = value.slice(0, 2);
                            }

                            // Ensure the value is less than 96
                            const numericValue = parseInt(value, 10);
                            const newValue = isNaN(numericValue) ? "" : Math.min(numericValue, 96);

                            onChangeLongTermData("maxDuration", newValue.toString());
                          }
                        }}
                        type="text"
                        onKeyPress={(e) => handleKeyPress(e)}
                        style={{ width: "50%" }}
                        // disabled={disable}
                        onWheel={(e) => e.target.blur()}
                      />
                      Months
                    </td>
                  </tr>
                </table>
              </div>
              <div className="col-lg-6 col-md-6">
                <table className="table">
                  <tr>
                    <td className="tableData">Additional Long Term Loan Amount: </td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {parseInt(longTermData.altlAmount)
                        .toLocaleString("en-IN")}
                    </td>
                  </tr>

                  <tr>
                    <td className="tableData">Additional Long Term Loan Eligible Amount: </td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {parseInt(longTermData.altlEligibleAmount)
                        .toLocaleString("en-IN")}
                    </td>
                  </tr>
                  <tr>
                    <td className="tableData">Additional Long Term Loan Amount Applied:</td>
                    <td className="tableData">
                      <InputFormFocus
                        placeholder={""}
                        value={longTermData.altlGiveableAmount}
                        onChange={(val: any) => {
                          let value = val.target.value;
                          const regex = /^[0-9]*$/;
                          if (value === "" || regex.test(value)) {
                            onChangeLongTermData("altlGiveableAmount", value);
                          }
                        }}
                        type="text"
                        onKeyPress={(e) => handleKeyPress(e)}
                        disabled={false}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="tableData">Additional Long Term Loan Rate Of Interest: </td>
                    <td className="tableData" style={{ paddingLeft: "30px" }}>
                      {longTermData.altlRoi}%
                    </td>
                  </tr>
                  <tr>
                    <td className="tableData">Previous Additional Outstanding Loan:</td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {parseInt(longTermData.previousOutstandingLoanAL)
                        .toLocaleString("en-IN")}
                    </td>
                  </tr>
                  {/* <tr>
                    <td className="tableData">Total Loan To Be Given AL:</td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {longTermData.altlTotalLoanToBeGiven
                        .toString()
                        .replace(/(\d)(?=(\d{2})+\d(?!\d))/g, "$1,")}
                    </td>
                  </tr> */}
                </table>
              </div>
              {longTermData.previousOutstandingLoan > 0 && (
                <span><b>Note : The amount displayed under “Total Loan to Be Given” is a provisional amount. From this amount, applicable Service Charges (if any), GST, Stamp Duty Charges, and Interest on previous outstanding loan will be deducted at the time of disbursement.
                  The displayed amount does not include these charges and represents the loan amount after adjusting the previous outstanding loan only.</b></span>

              )}
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-12 col-md-12">
        <div className="d-flex justify-content-center my-4">
          <ButtonComponent
            icon={""}
            value={"Calculate"}
            disabled={calculateButton}
            id="saveBtn"
            className={"btn btn-primary"}
            style={{ marginLeft: "10px" }}
            onClick={() => {
              getLongAndAdditionTermCal();
            }}
          />
        </div>
        <div className="row m-3 border border-danger p-3" style={{ borderRadius: 20 }}>
          <div className="col px-md-5">
            <div className="row">
              <table className="table">
                <tr>
                  <td className="tableData">Monthly Principle: </td>
                  <td className="tableData">Total Interest Payable</td>
                  <td className="tableData">Total Payment (Principal + Interest)</td>
                </tr>
                <tr>
                  <td className="tableData">
                    <i className="fa fa-inr"></i>
                    {longLoanEmi.toLocaleString("en-IN")}
                  </td>
                  <td className="tableData">
                    <i className="fa fa-inr"></i>
                    {longTotalInterestPayable.toLocaleString("en-IN")}
                  </td>
                  <td className="tableData">
                    <i className="fa fa-inr"></i>
                    {longTotalPayment.toLocaleString("en-IN")}
                  </td>
                </tr>
              </table>
            </div>
            <CanvasJSChart
              options={ltiOption}
            /* onRef = {ref => this.chart = ref} */
            />
          </div>

          <div className="col px-md-5">
            <div className="row">
              <table className="table">
                <tr>
                  <td className="tableData">Monthly Principle: </td>
                  <td className="tableData">Total Interest Payable</td>
                  <td className="tableData">Total Payment (Principal + Interest)</td>
                </tr>
                <tr>
                  <td className="tableData">
                    <i className="fa fa-inr"></i>
                    {aLTLLongLoanEmi.toLocaleString("en-IN")}
                  </td>
                  <td className="tableData">
                    <i className="fa fa-inr"></i>
                    {aLTLLongTotalInterestPayable.toLocaleString("en-IN")}
                  </td>
                  <td className="tableData">
                    <i className="fa fa-inr"></i>
                    {aLTLLongTotalPayment.toLocaleString("en-IN")}
                  </td>
                </tr>
              </table>
            </div>
            <CanvasJSChart
              options={altiOption}
            /* onRef = {ref => this.chart = ref} */
            />
          </div>
        </div>
        <div className="d-flex justify-content-center m-3">
          <div className="column">
            <h4>{!longTermEligibleLoan ? "" : "You're Eligible for Loan!"}</h4>

            <div className="d-flex justify-content-around m-3">
              <div className="row">
                <ButtonComponent
                  icon={""}
                  value={"Back"}
                  onClick={() => {
                    navigate("/LoanApprovalDashboard");
                    // toggleShowNext();
                  }}
                />
                <ButtonComponent
                  icon={""}
                  value={"Proceed"}
                  id="saveBtn"
                  className={"btn btn-primary"}
                  style={{ marginLeft: "10px" }}
                  disabled={!longTermEligibleLoan}
                  onClick={() => {
                    onLongTermSubmit();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ), [
    longTermData,
    calculateButton,
    longLoanEmi,
    longTotalInterestPayable,
    longTotalPayment,
    aLTLLongLoanEmi,
    aLTLLongTotalInterestPayable,
    aLTLLongTotalPayment,
    longTermEligibleLoan,
    disabled,
    onChangeLongTermData,
    handleKeyPress,
    navigate,
  ]);

  const getLoanRequestDataByIds = async () => {
    const param = {
      LoanId: state.Id,
    };

    const result = await APICall(getLoanRequestDataById, param);
    if ((result.Message == "Success" || result.Message == "Ok") && result.Data) {
      GetShortTermLoan();
      if (result.Data.LoanAmount != null && result.Data.LoanAmount > 0 && result.Data.LoanAmount != "") {
        setDisable(true);
        setIsDisabled(true);

        setFormDataOnEdit(result.Data.LoanType);
        setShortTermData({
          ...shortTermData,
          loanAmount: shortTermData.loanAmount,
          duration: shortTermData.duration,
        });
      }
    }
  };

  const getTermDataFn = async (TermData) => {
    let param = { MemberId: context?.MemberId, LoanType: TermData.value };
    let url;
    if (LoanTypeEnum.LONGTERM == TermData.value) {
      url = checkLongTermLoanEligibility;
    } else if (LoanTypeEnum.SHORTTERM == TermData.value) {
      url = checkShortTermLoanEligibility;
    }

    let res = await APICall(url, param);
   
    if (res?.Data?.length > 0) {
      setLoanEligibilityText(res.Data);
      hideLoader();
    }
    hideLoader();
  };

  const getDropDownDataApiCall = async () => {
    showLoader();
    // loanTypeOption
    const res = await APICall(getAllLoanTypeList, {});

    if (res && res.Data.length > 0) {
      let options = await res.Data;
      setLoanTypeOption(options);
      hideLoader();
    } else {
      setLoanTypeOption([]);
      notify(1, res.Message);
      hideLoader();
    }
  };

  const handleEligibilityRadio = async (e) => {
    let value = e.target.value;

    setTermSelection(value);
    showLoader();
    // Convert labels to lowercase
    const lowercaseData = loanTypeOption.map((item) => ({
      ...item,
      label: item.label.replaceAll(" ", "").toLowerCase(),
    }));

    // Find data with label "shortterm"
    const TermData = lowercaseData.find((item) => item.label === value.toLowerCase());
    setLoanTypeValue(TermData);

    getTermDataFn(TermData);
  };

  return (
    <div>
      {showNext && ["shortTerm", "Short Term"].includes(termSelection) ? (
        ShortTermComponent
      ) : showNext && ["longTerm", "Long Term"].includes(termSelection) ? (
        LongTermComponent
      ) : (
        <div className="form-group p-4 mt-2 border border-danger" style={{ borderRadius: 20 }}>
          {/* <FormWithHeader title="Step 1 : Select type of Loan"> */}
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            style={{ width: "50%", marginRight: "10px" }}
            onChange={handleEligibilityRadio}
            // onChange={(val: any) => {
            //   let value = val.target.value;
            //   setTermSelection(value);
            // }}
            className="my-2"
          >
            <FormControlLabel
              value="shortTerm"
              control={
                <Radio
                  color={["shortTerm", "Short Term"].includes(termSelection) ? "error" : "default"}
                  font-family={"Georama-Regular!important"}
                  disabled={isDisabled}
                />
              }
              label="Short Term"
              checked={["shortTerm", "Short Term"].includes(termSelection)}
            />
            <FormControlLabel
              value="longTerm"
              control={
                <Radio
                  color={["longTerm", "Long Term"].includes(termSelection) ? "error" : "default"}
                  font-family={"Georama-Regular!important"}
                  disabled={isDisabled}
                />
              }
              label="Long Term"
              checked={["longTerm", "Long Term"].includes(termSelection)}
            />

            <ButtonComponent
              icon={"fas fa-hand-point-right"}
              value={"Proceed"}
              className={"btn btn-primary"}
              style={{ marginLeft: "10px" }}
              id="saveBtn"
              onClick={() => {
                toggleShowNext();
              }}
              disabled={loanEligibilityText.length > 0 ? (loanEligibilityText.some((item) => !item.Status) ? true : false) : !isDisabled}
            />
          </RadioGroup>

          {/* <div
            className="p-2 d-flex justify-content-center"
            style={{ marginTop: 20 }}
          >
            
          </div> */}
          <div className="m-3 p-3 border border-danger" style={{ borderRadius: 20 }}>
            <h3 style={{ textAlign: "center" }}>Loan Eligibility</h3>
            <pre style={{ whiteSpace: "pre-line" }}>
              {loanEligibilityText.length > 0 ? (
                loanEligibilityText.map((val, ind) => {
                  return (
                    <>
                      <p className={val.Status ? "checkEligibilitySuccess" : "checkEligibilityError"}>{ind + 1 + ". " + val.Message}</p>
                    </>
                  );
                })
              ) : (
                <p className="loanEligibilityText">Data Not Available</p>
              )}
            </pre>
          </div>
          {/* </FormWithHeader> */}
        </div>
      )}
    </div>
  );
};

export default LoanType;
